<!--
 * @Author: wangchao wchao_sr@neusiri.com
 * @Date: 2023-09-01 09:34:24
 * @LastEditors: wangchao wchao_sr@neusiri.com
 * @LastEditTime: 2023-09-07 20:37:56
 * @FilePath: \Collection\src\views\ModuleAndLang\components\Subscribe.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="w800">
    <div class="header-wrapper mb20">
      <b class="fs16">设置订阅入口</b>
      <a-button type="primary" @click="subscribeAdd">新增</a-button>
    </div>
    <a-table
      :dataSource="integratedConfig.integratedSubscribeList"
      :columns="columns"
      :pagination="false"
    >
      <template #bodyCell="{ column, record ,index}">
        <template v-if="column.key === 'selectValue'">
          {{
            subscribeSelectList.filter(item => item.value === record.scene)[0]
              ?.label
          }}
        </template>
        <template v-if="column.key === 'openPC'">
          <a-switch
            v-model:checked="record.pcStatus"
            checked-children="启用"
            un-checked-children="禁用"
            :checkedValue="1"
            :unCheckedValue="0"
            @change="handleSwitchChange(record, index)"
          />
        </template>
        <template v-if="column.key === 'openM'">
          <a-switch
            v-model:checked="record.mStatus"
            checked-children="启用"
            un-checked-children="禁用"
            :checkedValue="1"
            :unCheckedValue="0"
            @change="handleSwitchChange(record, index)"
          />
        </template>
        <template v-if="column.key === 'operation'">
          <a class="mr10" @click="editRow(record, index)">编辑</a>
          <a-popconfirm
            class="ml10"
            title="是否确认删除?"
            ok-text="是"
            cancel-text="否"
            @confirm="delRow(index)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import { inject, ref, toRefs } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: '订阅场景',
        dataIndex: 'selectValue',
        key: 'selectValue',
        align: 'center'
      },
      {
        title: 'PC端开启订阅',
        dataIndex: 'openPC',
        key: 'openPC',
        align: 'center'
      },
      {
        title: 'M端开启订阅',
        dataIndex: 'openM',
        key: 'openM',
        align: 'center'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        align: 'center'
      }
    ])
    return {
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
